export const servicesEnum = {
  Educativo: 126,
  'Terapia de Habla': 127,
  'Terapia Ocupacional': 128,
  'Terapia Psicológica': 129,
  'Terapia Física': 130,
  Otros: 134,
  'Terapia Oromotora': 672,
  'Asistencia Tecnológica': 704,
  'Educación Física Adaptada': 721,
  'Educación Física Adaptada/Combinada': 1749,
  'Servicio para Ciegos': 1768,
  'Servicio para Sordos': 1769,
};
